import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

export default reduxApi({

  getNguonDon: {
    url: `${API_URL}/nguonTiepNhanDons?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getHuongXuLyDonSearch: {
    url: `${API_URL}/huongXuLys?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getQuyTrinhXuLyHistory: {
    url: `${API_URL}/lichSuQuaTrinhXuLys`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getThongTinXuLy: {
    url: `${API_URL}/xuLyDons/thongTinXuLyDon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getCurrentForm: {

    url: `${API_URL}/currentForm`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getTrangThaiTTXM: {
    url: `${API_URL}/trangThaiTTXMs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },

  postTuXuLyDon: {

    url: `${API_URL}/xuLyDons/tuXuLy`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },

  patchTuXuLy: {
    url: `${API_URL}/xuLyDons/tuXuLy/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },

  postXuLyDon: {

    url: `${API_URL}/xuLyDons`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },

  patchXuLyDon: {
    url: `${API_URL}/xuLyDons/:id`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },

  patchDinhChiDon: {

    url: `${API_URL}/xuLyDons/:id/dinhChiDon`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },

  getDonDetail: {
    url: `${API_URL}/dons/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getDonCuDetail: {
    url: `${API_URL}/donCus/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  }

}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/letterProcessingWorkFlow.js